import * as React from 'react';


import Typography from '@mui/material/Typography';




export default function Contact() {
  return (
    <div>
      
      
		<Typography variant="h2" gutterBottom>Contact</Typography>
		<div >								<p>
									Christian Burmer<br/>
									<br/>
									Saliterstraße, 3<br/>
									83101 Rohrdorf
								</p>

								<h4>--</h4> 
								<p>
									Telefon: 080321385<br/>
									E-Mail: cbu60@yahoo.de
								</p></div>
     
    </div>
  );
}
